/* ============
 * Create Page
 * ============
 *
 * This is the page for adding product.
 */
import addProductGroup from './../../productGroups/create/create.vue';
import productService from './../../../../services/product';
import productGroupService from './../../../../services/product-group';
import productTypeService from './../../../../services/productType';
import productSubtypeService from './../../../../services/productSubtype';
import productDepositService from './../../../../services/productDeposit';
import depositSystemService from './../../../../services/depositSystem';
import countryService from './../../../../services/country';
import productPackagingService from '../../../../services/productPackaging';
import productRecommendationService from '../../../../services/productRecommendation';
import taxService from './../../../../services/tax';
import vmpService from './../../../../services/vinmonopolet';
import productTransformer from './../../../../transformers/product';
import productCreatePopup from './../../../../components/productCreatePopup/productCreatePopup.vue';
import addProductPackaging from './../../../../pages/withNavigation/productPackagings/create/create.vue';
import organizationSettingsService from './../../../../services/organizationSettings';
import Forms from './../../../../utils/forms/forms';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      form: new Forms({
        productTypeId: {
          value: '',
          type: 'hidden',
        },
        productType: {
          value: '',
          type: 'cascader',
        },
        productSubtypeId: {
          value: '',
          type: 'hidden',
        },
        productSubtype: {
          value: '',
          type: 'cascader',
        },
      }),
      childProductForm: new Forms({
        productParentId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
      }),
      productInfoForm: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        price: {
          value: '',
          type: 'float',
        },
        productPackagingId: {
          value: '',
          type: 'select',
        },
        country: {
          value: '',
          type: 'select',
        },
        containsAlcohol: {
          value: '',
          type: 'switch',
        },
        alcoholPercentage: {
          value: '',
          type: 'float',
        },
        vmp: {
          value: '',
          type: 'text',
          attributes: {
            hasButton: true,
            buttonLabel: this.$t('static.products.create.vmp.fetch'),
            buttonHandler: this.vmpImportHandler,
          },
        },
        taxId: {
          value: '',
          type: 'select',
        },
        deposit: {
          value: '',
          type: 'switch',
        },
        depositSystemId: {
          value: '',
          type: 'select',
        },
        productDepositId: {
          value: '',
          type: 'select',
        },
        duration: {
          value: '',
          type: 'number',
        },
        breaktime: {
          value: '',
          type: 'number',
        },
        isActive: {
          value: '',
          type: 'switch',
        },
        recommendations: {
          value: '',
          type: 'select',
        },
        gtin: {
          value: '',
          type: 'text',
        },
        syncToWoo: {
          value: '',
          type: 'switch',
        },
      }),
      product: {
        fieldsJSON: {},
      },
      defaultProductTypeName: '',
      loading: false,
      tabIndex: '1',
    };
  },

  computed: {
    ...mapGetters({
      productGroups: 'allProductGroups',
      allProductTypes: 'allProductTypes',
      allProductSubtypes: 'allProductSubtypes',
      productPackagings: 'allProductPackagings',
      productDeposits: 'allProductDeposits',
      depositSystems: 'allDepositSystems',
      productRecommendations: 'allProductRecommendations',
      taxes: 'allTaxes',
      account: 'account',
      organizationSettings: 'organizationSettings',
      countries: 'allCountries',
    }),
    productTypes() {
      const maxId = Math.max(...this.allProductTypes.map(p => p.id));
      const productTypes = [...this.allProductTypes];
      productTypes.push({
        id: maxId + 1,
        name: 'Child',
        group: '',
        subGroup: '',
      });
      return productTypes;
    },
    productType() {
      if (typeof this.form.productTypeId !== 'undefined') {
        return this.productTypes.find(type => type.id.toString() === this.form.productTypeId.toString());
      }
      return null;
    },
    productTypeName() {
      if (typeof this.form.productTypeId !== 'undefined') {
        const productType = this.productTypes.find(type => type.id.toString() === this.form.productTypeId.toString());
        if (productType) {
          return productType.name;
        }
      }
      return null;
    },
    productTypeValue() {
      const productTypeValue = [];
      if (this.productType) {
        if (this.productType.group) {
          productTypeValue.push(this.productType.group);
        }
        productTypeValue.push(this.productType.id);
      }
      return productTypeValue;
    },

    userHasVinmonopolet() {
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Vinmonopolet') {
            return true;
          }
        }
      }

      return false;
    },

    hasWooModule() {
      if (this.account.modules.length > 0) {
        if (this.account.modules.find(module => module.name === 'WordPress WooCommerce')) return true;
      }
      return false;
    },
  },

  watch: {

    'productInfoForm.alcoholPercentage': function (value) {
      if (value >= 0.7) {
        this.productInfoForm.containsAlcohol = true;
      } else {
        this.productInfoForm.containsAlcohol = false;
      }
    },

    'productInfoForm.depositSystemId': function (value) {
      if (value) {
        this.productInfoForm.showField('productDepositId');
      } else {
        this.productInfoForm.hideField('productDepositId');
      }

      const productType = this.productTypes.find(type => type.id.toString() === this.form.productTypeId.toString());
      if (productType.name !== 'Service') {
        this.productInfoForm.hideField('duration');
        this.productInfoForm.hideField('breaktime');
      }
    },

    'productInfoForm.productPackagingId': function (value) {
      const packaging = this.productPackagings.all.find(x => x.id === parseInt(value));
      if (packaging) {
        this.productInfoForm.setFieldValue('depositSystemId', packaging.depositSystemId);
        this.productInfoForm.setFieldValue('productDepositId', packaging.productDepositId);
        this.productInfoForm.setFieldValue('deposit', true);
      }

      if (!packaging || !packaging.depositSystemId || packaging.depositSystemId === '') {
        this.productInfoForm.setFieldValue('depositSystemId', '');
        this.productInfoForm.setFieldValue('productDepositId', '');
        this.productInfoForm.setFieldValue('deposit', false);
      }
    },

    /**
     * Watches if user has Appointment module.
     *
     * @param  {Object} account    The account.
     */
    account() {
      this.toogleProductConfig(this.form.productTypeId);
      if (!this.hasWooModule) {
        this.form.hideField('syncToWoo');
      }
    },
    /**
     * Watches if user has default product type on org settings.
     *
     * @param  {Object} account    The account.
     */
    organizationSettings(organizationSettings) {
      if (organizationSettings.defaultProductTypeName) {
        this.defaultProductTypeName = organizationSettings.defaultProductTypeName;
        this.setDefaultProductType();
      }
    },
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} productTypes    The product types list.
     */
    allProductTypes() {
      const productTypes = this.productTypes;
      if (productTypes) {
        const options = productTypes.reduce((groups, item) => {
          const group = (groups[item.group] || {
            label: this.$t(`static.products.types.${this.camalize(item.group)}`),
            value: item.group,
            children: [],
          });
          if (item.group) {
            group.children.push({
              label: this.$t(`static.products.types.${this.camalize(item.name)}`),
              value: item.id,
            });
            groups[item.group] = group;
          } else {
            groups[item.id] = {
              label: this.$t(`static.products.types.${this.camalize(item.name)}`),
              value: item.id,
            };
          }
          return groups;
        }, {});
        const opt = Object.keys(options).map((option) => {
          const item = options[option];
          if (item.children) {
            item.children = Object.keys(item.children).map((child) => {
              const c = item.children[child];
              if (c.children) {
                c.children = Object.keys(c.children).map(t => c.children[t]);
              }
              return c;
            });
          }
          return item;
        });

        this.form.setOptions('productType', opt.filter(pt => pt.label !== this.$t('static.products.types.bundle')).sort((a, b) => ((a.label > b.label) ? 1 : -1)));
      }
    },

    productGroups() {
      this.productInfoForm.setOptions('productGroupId', this.productGroups.all);
      this.productInfoForm.setExtraAttr('productGroupId', {
        multiple: true,
      });
    },

    productRecommendations(recommendations) {
      this.productInfoForm.setOptions('recommendations', recommendations);
      this.productInfoForm.setExtraAttr('recommendations', {
        multiple: true,
      });
    },

    productPackagings() {
      this.productInfoForm.setOptions('productPackagingId', this.productPackagings.all);
    },

    countries(countries) {
      this.productInfoForm.setOptions('country', countries.items.map(c => ({ id: c.name, name: this.$t(`country.translated.${c.code}`) })));
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} taxes    The taxes list.
     */
    taxes() {
      this.productInfoForm.setOptions('taxId', this.taxes.all.map(tax => ({
        id: tax.id,
        name: tax.taxPercentage,
      })));
    },

    /**
     * Watches product type to hide or show product config.
     *
     * @param  {Integer} typeId    The product type id.
     */
    'form.productTypeId': function (typeId) {
      this.setOptionsForProductSubtype();

      if (typeof typeId !== 'undefined') {
        const productType = this.productTypes.find(type => type.id.toString() === typeId.toString());
        this.productInfoForm.hideField('duration');
        this.productInfoForm.hideField('breaktime');
        this.productInfoForm.hideField('alcoholPercentage');
        this.productInfoForm.hideField('productPackagingId');
        this.productInfoForm.hideField('vmp');
        this.productInfoForm.hideField('country');
        this.productInfoForm.hideField('deposit');
        this.productInfoForm.hideField('productDepositId');
        this.productInfoForm.hideField('depositSystemId');
        this.productInfoForm.hideField('containsAlcohol');
        this.productInfoForm.hideField('recommendations');

        if (productType) {
          if (productType.name === 'Child') {
            this.childProductForm.showField('productParentId');
            return;
          }
          if (productType.name === 'Service') {
            this.productInfoForm.showField('duration');
            this.productInfoForm.showField('breaktime');
          }
          if (productType.group === 'Beverage') {
            this.productInfoForm.showField('productPackagingId');
            this.productInfoForm.setQuickForm('productPackagingId', addProductPackaging);
            this.productInfoForm.showField('country');
            this.productInfoForm.showField('deposit');
            this.productInfoForm.showField('containsAlcohol');
            this.productInfoForm.setOptions('productDepositId', this.productDeposits.all.map(deposit => ({ id: deposit.id, name: deposit.name })));
            this.productInfoForm.setOptions('depositSystemId', this.depositSystems.all.map(depositSystem => ({ id: depositSystem.id, name: depositSystem.name })));
          }
          if (productType.subGroup === 'Alcohol') {
            this.productInfoForm.showField('alcoholPercentage');
            this.productInfoForm.showField('vmp');
          }
        }
      }
    },

    /**
     * Watches product type to assign the id value
     *
     * @param  {Array} productType    The product type.
     */
    'form.productType': function (arrayValue) {
      const [productyTypeId] = arrayValue.slice(-1);
      this.form.productTypeId = productyTypeId;
    },
    /**
     * Watches product subtype to assign the id value
     *
     * @param  {Array} productSubtype    The product type.
     */
    'form.productSubtype': function (arrayValue) {
      const [productSubtypeId] = arrayValue.slice(-1);
      this.form.productSubtypeId = productSubtypeId;
    },

    'productInfoForm.deposit': function (deposit) {
      if (deposit) {
        // this.productInfoForm.showField('productDepositId');
        this.productInfoForm.showField('depositSystemId');
      } else {
        this.productInfoForm.hideField('productDepositId');
        this.productInfoForm.hideField('depositSystemId');
      }
    },
    allProductSubtypes() {
      this.setOptionsForProductSubtype();
    },
  },

  mounted() {
    this.form.setExtraAttr('productGroupId', {
      multiple: true,
    });
    this.form.setExtraAttr('recommendations', {
      multiple: true,
    });
    this.form.hideField('productTypeId');
    this.productInfoForm.hideField('productDepositId');
  },

  created() {
    this.form.setQuickForm('productGroupId', addProductGroup);
    this.hideProductConfig();
    this.loading = true;
    Promise.all([
      productGroupService.all(),
      productTypeService.all(),
      productSubtypeService.all(),
      countryService.all(),
      productDepositService.all(),
      depositSystemService.all(),
      taxService.all(),
      productPackagingService.all(),
      productRecommendationService.all(),
      organizationSettingsService.show(),
    ]).then(() => {
      this.productInfoForm.taxId = 4; // Default to 25% tax
      this.productInfoForm.isActive = true;
      this.loading = false;
    });
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalSize: 'SET_MODAL_SIZE',
      setModalProps: 'SET_MODAL_PROPS',
    }),
    vmpImportHandler() {
      if (!this.userHasVinmonopolet) {
        this.$alert(this.$t('static.products.syncVmp.noModuleWarning'), 'Warning', {
          dangerouslyUseHTMLString: true,
        });
        return;
      }
      this.productInfoForm.loading = true;
      const vmp = this.productInfoForm.vmp;
      if (!vmp) {
        this.$message({
          message: this.$t('static.products.syncVmp.inputRequired'),
          type: 'error',
        });
        return;
      }

      this.productInfoForm.disableField('vmp');
      const self = this;

      vmpService.findProduct(vmp)
        .then((data) => {
          this.productInfoForm.loading = false;
          if (data) {
            this.setDefaultProductType(data.productType);
            this.$nextTick(() => {
              self.productInfoForm.enableField('vmp');
              self.productInfoForm.name = data.name;
              self.productInfoForm.price = data.ddpVmp;
              self.productInfoForm.alcoholPercentage = data.alcoholPercentage;
              self.productInfoForm.country = data.country;
              self.productInfoForm.vmp = data.vmp;
              self.productInfoForm.containsAlcohol = +(data.alcoholPercentage > 0);
            });
          }
        })
        .catch(() => {
          this.$message({
            message: this.$t('static.product.create.vmp.warning'),
            type: 'error',
          });
          this.productInfoForm.enableField('vmp');
          this.productInfoForm.loading = false;
        });
    },
    /**
     * Search remote function
     */
    searchMethod(search) {
      return Promise.all([
        productService.search({
          search,
        }),
      ]);
    },

    toogleProductConfig(typeId) {
      const hasAppointment = this.account.modules !== undefined ? this.account.modules.filter(m => (
        m.name === 'Appointment'
      )).length > 0 : false;
      if (typeId) {
        const type = this.productTypes.filter(t => (
          typeId.toString() === t.id.toString()
        ))[0];

        if (type.name === 'Service' && hasAppointment) {
          this.showProductConfig();
        } else {
          this.hideProductConfig();
        }
      }
    },

    createChildProduct() {
      if (!this.childProductForm.productParentId.id) {
        this.childProductForm.recordErrors({
          productParentId: ['Parent product is required.'],
        });
        return;
      }
      this.childProductForm.loading = true;
      productService.show(this.childProductForm.productParentId.id).then((product) => {
        this.product = product;
        this.form.productTypeId = product.productTypeId;
        this.form.productType = this.productTypeValue;
        this.productInfoForm.assignData(this.product);
        const childProductCount = product.childProducts.length + 1;
        this.productInfoForm.name = `${this.product.name} - Child(${childProductCount})`;
        this.childProductForm.loading = false;
      });
    },

    setOptionsForProductSubtype() {
      if (!this.allProductSubtypes.length) {
        this.form.hideField('productSubtype');
        return;
      }
      this.form.showField('productSubtype');
      if (this.form.productType.length) {
        const typeId = this.form.productType[this.form.productType.length - 1];

        const options = [...this.allProductSubtypes]
          .filter(s => +s.productTypeId === +typeId)
          .reduce((groups, item) => {
            const group = groups[item.type] || {
              label: item.type,
              value: item.type,
              children: [],
            };
            if (item.type) {
              group.children.push({
                label: item.name,
                value: item.id,
              });
              groups[item.type] = group;
            } else {
              groups[item.id] = {
                label: item.name,
                value: item.id,
              };
            }
            return groups;
          }, {});
        const opt = Object.keys(options).map((option) => {
          const item = options[option];
          if (item.children) {
            item.children = Object.keys(item.children).map((child) => {
              const c = item.children[child];
              if (c.children) {
                c.children = Object.keys(c.children).map(t => c.children[t]);
              }
              return c;
            });
          }
          return item;
        });
        if (opt.length) {
          this.form.setOptions(
            'productSubtype',
            opt.sort((a, b) => (a.label > b.label ? 1 : -1))
          );
          return;
        }
        this.form.hideField('productSubtype');
        return;
      }
    },

    /**
     * Hide fields from product configuration.
     */
    hideProductConfig() {
      /* this.form.hideField('breaktime');
      this.form.hideField('duration');
      this.form.hideField('appointable');*/
    },

    /**
     * Show fields from product configuration.
     */
    showProductConfig() {
      /* this.form.showField('breaktime');
      this.form.showField('duration');
      this.form.showField('appointable');*/
    },
    /**
     * Method to store the product.
     *
     * @param  {Object} product    The product
     * @param  {Function} errorCallback    The error callback
     */
    store() {
      this.form.loading = true;
      let obj = {};
      if (this.product && this.product.id) {
        this.product.fieldsJSON = null;
        const productData = productTransformer.send(this.product);
        obj = Object.assign({}, productData, this.form.data(), this.productInfoForm.data());
        obj.productParentId = this.product.id;
        obj.id = null;
      } else {
        obj = Object.assign({}, this.form.data(), this.productInfoForm.data());
      }

      obj.appointable = false;

      const product = productTransformer.send(obj);

      productService.store(product)
        .then((data) => {
          this.productInfoForm.resetValues();
          this.form.productTypeId = '';
          this.form.productType = '';
          this.form.productSubtype = '';
          this.form.productSubtypeId = '';
          this.product = {
            fieldsJSON: {},
          };
          this.form.loading = false;
          this.setDefaultProductType();
          this.productInfoForm.isActive = true;
          this.setModalContent(() => productCreatePopup);
          this.setModalSize('full');
          this.toggleModal(true);
          this.setModalProps({
            productId: data.id,
          });
        })
        .catch((errors) => {
          if (errors.productSubtypeId) {
            errors.productSubtype = errors.productSubtypeId;
          }
          this.productInfoForm.recordErrors(errors);
          this.form.recordErrors(errors);
          this.form.loading = false;
        });
    },
    setDefaultProductType(productTypeName) {
      const typeName = productTypeName || this.defaultProductTypeName;
      const productType = this.productTypes.find(type => type.name.toString() === typeName.toString());
      const productTypeValue = [];
      if (productType) {
        if (productType.group) {
          productTypeValue.push(productType.group);
        }
        if (productType.subGroup) {
          productTypeValue.push(productType.subGroup);
        }
        productTypeValue.push(productType.id);
      }
      this.form.productType = productTypeValue;
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VProductPriceTable: require('./../../../../components/productPriceTable/productPriceTable.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/products/create/create.js